/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Kind of a calculated price.   (bipro-datentypen::Beitrag)     * `Gross` - german: Brutto   * `Net`   - german: Netto
 */
export const PriceKind = {
  Gross: 'Gross',
  Net: 'Net',
} as const;
export type PriceKind = (typeof PriceKind)[keyof typeof PriceKind];
